import { defaultCountries as countries, usePhoneInput } from 'react-international-phone';
import { PhoneProps } from './types';
import { cn } from '@utils/cn';

export const Phone = ({ className, value }: PhoneProps) => {
  const { inputValue } = usePhoneInput({
    defaultCountry: 'us',
    value: value || '',
    countries,
  });

  if (!value) return null;
  return (
    <a
      onClick={(e) => e.stopPropagation()}
      href={`tel: ${inputValue}`}
      className={cn('whitespace-nowrap text-left hover:underline', className)}>
      {inputValue}
    </a>
  );
};
